var Contractor = (function () {

  function deleteObjects(ids) {
    return $.ajax({
      url: Url.action('api/contractors'),
      type: 'DELETE',
      data: { ids: ids }
    })
    .done(() => {
        _refreshTable(true, ids);
    })
    .fail(() => {
        alert('Удаление невозможно: с данным подрядчиком связаны ТС, работы, протяженные объекты, точечные объекты, населенные пункты или контракты.');
    });
  };

  function _show(id) {
    var modal = ModalConductor.activate(ContractorViewModal, id,
      (contractorId) => {
        deleteObjects([contractorId]).done(() => {
            modal.close();
        });
      })
    .on('closed', (modalResult) => _refreshTable());
  }

  function _del(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      deleteObjects(ids);
    }
  }

  function _add() {
    ModalConductor.activate(ContractorEditModal)
     .on('closed', (modalResult) => {
       if (modalResult.ok) {
         _refreshTable();
       }
     });
  }

    function _refreshTable(resetChecked, idsForDeselect) {
        var table = $('#ContractorListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, false, idsForDeselect);
    };

  return {
    show: _show,
    del: _del,
    add: _add
  };
}())
